"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncIterableSplitOnAny = asyncIterableSplitOnAny;

var _toArray = _interopRequireDefault(require("../../$to-array/to-array"));

var _asyncIterableSplitWith = require("../../$split-with/internal/async-iterable-split-with");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncIterableSplitOnAny(source, separators) {
  const _separators = (0, _toArray.default)(separators);

  return (0, _asyncIterableSplitWith.asyncIterableSplitWith)(source, value => _separators.includes(value));
}